import React, { useCallback, useState } from "react";
import { Button } from "evergreen-ui";

const PromiseButton = ({ promiser, ...props }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(() => {
    setLoading(true);
    promiser()
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [promiser]);

  return <Button {...props} isLoading={loading} onClick={handleClick} />;
};

export default PromiseButton;
